import {text_mod_25, } from "../text/Text.js";
export const module25 = {
  title:
    "Урок 25. Табличне множення числа 3. Знаходження частини від числа.​​",
  questions: [
    {
      id: 1,
      onlyText: true,
      text: text_mod_25, },
    ]
  }
